import React from 'react';
import KPIDetail from './KPIDetail';

const KPISection = ({ name, index, indicators }) => {
  return (
    <div className="kpi-section">
      <h5 data-testid={`kpi-section-header-${index}`}>{name}</h5>
      <div className="kpi-section-details">
        {indicators.map((indicator, indicatorIndex) => (
          <KPIDetail
            name={indicator.name}
            value={indicator.value}
            trend={indicator.trend}
            link={indicator.link}
            identifier={`section-${index}-detail-${indicatorIndex}`}
            key={`kpi-${indicator.name}`}
          />
        ))}
      </div>
    </div>
  );
};

export default KPISection;
